// PERSISTED

// NON PERSISTED

export const getDataLoadRequested = (state) => {
  return state.VNDataLoadManager.get('dataLoadRequested')
}

export const getLastDataLoadInitiated = (state) => {
  return state.VNDataLoadManager.get('lastDataLoadInitiated')
}

export const getLastDataLoadCompleted = (state) => {
  return state.VNDataLoadManager.get('lastDataLoadCompleted')
}

export const getBaseLoadRequested = (state) => {
  return state.VNDataLoadManager.get('baseLoadRequested')
}

export const getShouldBaseLoadMenus = (state) => {
  return state.VNDataLoadManager.get('shouldBaseLoadMenus')
}

export const getLastBaseLoadInitiated = (state) => {
  return state.VNDataLoadManager.get('lastBaseLoadInitiated')
}

export const getLastBaseLoadCompleted = (state) => {
  return state.VNDataLoadManager.get('lastBaseLoadCompleted')
}

export const getSections = (state) => {
  return state.VNDataLoadManager.get('sections') || []
}

export const getSuccessCheck = (state) => {
  return state.VNDataLoadManager.get('successCheck')
}

export const getFailureCheck = (state) => {
  return state.VNDataLoadManager.get('failureCheck')
}
